import { createValidator } from "@/lib/validators/limit"
import * as y from "yup"

export const breakdownValidator = createValidator(
  y.array(
    y.object({
      id: y.string().optional(),
      type: y.string().required(),
      remark: y.string().required(),
      startedAt: y.string().required(),
      endedAt: y.string().optional(),
    })
  )
)
